<template>
  <div class="overlap">
    <div class="overlap__container">
      <div  class="overlap__circle-container"
           :class="{'overlap__circle-container_active' : isActive}">
        <div class="overlap__circle-small"></div>
        <div class="overlap__circle-big"></div>
      </div>
      <div class="overlap__button-wrapper" >
      <button @click="fullScreenMode" class="overlap__button" :class="{'overlap__button_active' : isActive}">
        view</button>
    </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */

  import AttributeReport from './AttributeReport'
import VennDiagramPopup from '../common/VennDiagramPopup'
/**
   * Overlap component used in {@link AttributeReport}
   */
export default {
  name: 'Overlap',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * callback to open {@link VennDiagramPopup} modal
     */
    fullScreenMode () {
      this.$emit('show-overlap')
    }
  }
}
</script>

<style scoped lang="scss">
  .overlap {
    display: flex;
    flex: 1 1 100%;

    &__container {
      display: flex;
      flex: 1 1 100%;
      align-items: center;
    }

    &__button-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1 1 100%;

    }
    &__button {
      display: flex;
      align-items: center;
      height: 40px;
      flex: 0 1 50%;
      padding: 0 20px;
      white-space: nowrap;
      background-color: transparent;
      color: $rfx-dark-march;
      border-radius: 4px;
      border: 2px solid $rfx-almost-white;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      justify-content: center;
      outline: none;
      pointer-events: none;

      &_active {
        color: #000;
        pointer-events: auto;
        cursor: pointer;
      }
    }

    &__circle-container {
      height: 140px;
      width: 200px;
      flex: 0 0 200px;
      color: $rfx-medium-grey;
      position: relative;

      &_active {
        color:$rfx-bright-blue;
      }
    }
    &__circle-small,
    &__circle-big {
      opacity: 0.5;
      position: absolute;
      color: inherit;
      background-color: currentColor;
      border-radius: 50%;

    }
    &__circle-big {
      top: 0;
      left: 30px;
      width: 140px;
      height: 140px;
    }

    &__circle-small {
      top: 50%;
      left: 135px;
      width: 100px;
      height: 100px;
      transform: translateY(-50%);

    }

  }
</style>
